import React from "react";
import { TableHead, TableRow, TableCell, TableSortLabel, Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import { visuallyHidden } from "@mui/utils";

const COLUMNS = [
  { id: "email", label: "Email", align: "center", sortable: true },
  { id: "date", label: "Date", align: "center", sortable: true },
  { id: "status", label: "Status", align: "center", sortable: true },
  { id: "paymentStatus", label: "Payment Status", align: "center", sortable: true },
  { id: "action", label: "Action", align: "center", sortable: false },
  { id: "cancelledFromDFY", label: "Cancelled from DFY", align: "center", sortable: false },
];

/**
 * Styled TableRow for header with column dividers
 */
const StyledHeaderRow = styled(TableRow)(() => ({
  "& .MuiTableCell-root": {
    backgroundColor: "#E9E9EC",
    borderBottom: "1px solid #E9E9EC",
    color: "#61616F",
  },
  "& .MuiTableCell-root::after": {
    content: '""',
    position: "absolute",
    top: 8,
    right: 0,
    bottom: 18,
    borderRight: "2px solid #CECED3",
    height: "50%",
    backgroundColor: "#CECED3",
  },
  "& .MuiTableCell-root:last-child::after": {
    content: "none",
  },
}));

/**
 * Table header component for orders table with sortable columns
 */
const OrderTableHeader = ({ sortBy, sortOrder, onSortChange }) => {
  const handleSort = (columnId) => {
    if (onSortChange) {
      onSortChange(columnId);
    }
  };

  return (
    <TableHead sx={{ background: "#E9E9EC", borderRadius: "10px" }}>
      <StyledHeaderRow>
        {COLUMNS.map((column) => (
          <TableCell
            key={column.id}
            align={column.align}
            sortDirection={sortBy === column.id ? sortOrder : false}
          >
            {column.sortable ? (
              <TableSortLabel
                active={sortBy === column.id}
                direction={sortBy === column.id ? sortOrder : "desc"}
                onClick={() => handleSort(column.id)}
                sx={{
                  "&.MuiTableSortLabel-root": {
                    color: "#61616F",
                  },
                  "&.MuiTableSortLabel-root:hover": {
                    color: "#3f3f46",
                  },
                  "&.Mui-active": {
                    color: "#3f3f46",
                  },
                  "& .MuiTableSortLabel-icon": {
                    color: "#61616F !important",
                  },
                }}
              >
                {column.label}
                {sortBy === column.id ? (
                  <Box component="span" sx={visuallyHidden}>
                    {sortOrder === "desc" ? "sorted descending" : "sorted ascending"}
                  </Box>
                ) : null}
              </TableSortLabel>
            ) : (
              column.label
            )}
          </TableCell>
        ))}
      </StyledHeaderRow>
    </TableHead>
  );
};

export default OrderTableHeader;